
import React from "react";
import './load.css';

export default function Load({ titulo }) {


    return (
        <div className="modal-load">

            <div className="load-caixa">
                <div className="loader"></div>
                <div className="loader-texto">{titulo}</div>
            </div>

        </div>
    )
}